export default __webpack_public_path__ + "static/media/63t.ec05d7a5.jpg";